// extracted by mini-css-extract-plugin
export default {"wrapper":"AnimatedProkoIcon_wrapper__TEwfs","ring":"AnimatedProkoIcon_ring__HCPSn","spinning":"AnimatedProkoIcon_spinning__rs0B5","ringSpinY":"AnimatedProkoIcon_ringSpinY__5mxip"};